/** Free local GSTIN check (length · structure · state code · PAN · check character · billing state) + duplicate check in SUNTRONIX ONE. Never a government verification. */
import { useEffect, useState } from "react";
import api from "@/lib/api";
import { CheckCircle2, AlertTriangle } from "lucide-react";

export function useGstinCheck(gstin, billingState, accountId) {
  const [v, setV] = useState(null);
  useEffect(() => {
    const g = (gstin || "").replace(/\s/g, "");
    if (g.length < 2) { setV(null); return undefined; }
    const t = setTimeout(() => api.get("/gst-registry/validate", { params: { gstin: g, billing_state: billingState || undefined, account_id: accountId || undefined } }).then(({ data }) => setV(data)).catch(() => setV(null)), 250);
    return () => clearTimeout(t);
  }, [gstin, billingState, accountId]);
  return v;
}

export function GstinCheck({ v, confirm, setConfirm, testid = "gstin-check" }) {
  if (!v || !v.gstin) return null;
  const dup = v.existing_customers || [];
  return (
    <div className="mt-1 space-y-1 text-[10.5px]" data-testid={testid}>
      <div className="flex flex-wrap gap-x-3 gap-y-0.5">
        {(v.checks || []).map((c) => (
          <span key={c.key} className={`inline-flex items-center gap-0.5 ${c.ok ? "text-emerald-700" : "text-rose-700"}`} data-testid={`${testid}-${c.key.toLowerCase()}`}>
            {c.ok ? <CheckCircle2 className="h-3 w-3" /> : <AlertTriangle className="h-3 w-3" />}{c.label}
          </span>))}
      </div>
      {!v.valid_format && <div className="font-semibold text-rose-700" data-testid={`${testid}-review`}>GSTIN REQUIRES REVIEW — can be saved, flagged for review</div>}
      <div className="text-slate-400">Format check only — not a government verification</div>
      {dup.length > 0 && (
        <label className="flex items-start gap-1.5 rounded border border-amber-300 bg-amber-50 px-2 py-1 text-amber-900" data-testid={`${testid}-duplicate`}>
          <input type="checkbox" checked={!!confirm} onChange={(e) => setConfirm(e.target.checked)} className="mt-0.5" data-testid={`${testid}-confirm`} />
          <span>Already stored on {dup.map((o) => `${o.customer_code || ""} ${o.account_name || ""}`.trim()).join(", ")} — I confirm this is correct</span>
        </label>)}
    </div>
  );
}
